import { render } from "./estateClients.vue?vue&type=template&id=1f89c9f6&scoped=true"
import script from "./estateClients.vue?vue&type=script&lang=js"
export * from "./estateClients.vue?vue&type=script&lang=js"

import "./estateClients.vue?vue&type=style&index=0&id=1f89c9f6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89c9f6"]])

export default __exports__